/**
 * Browser engines available to agent-driven test sessions.
 *
 * Chromium remains the default. Firefox and WebKit deliberately identify
 * Playwright engines rather than branded browsers.
 *
 * @module browser-engine
 */

export const BROWSER_ENGINES = ['chromium', 'firefox', 'webkit'] as const;

export type BrowserEngine = (typeof BROWSER_ENGINES)[number];

export const DEFAULT_BROWSER_ENGINE: BrowserEngine = 'chromium';

export const BROWSER_ENGINE_LABELS: Record<BrowserEngine, string> = {
  chromium: 'Chromium',
  firefox: 'Firefox',
  webkit: 'WebKit',
};

export function isBrowserEngine(value: unknown): value is BrowserEngine {
  return typeof value === 'string' && BROWSER_ENGINES.includes(value as BrowserEngine);
}
